module.exports = __webpack_public_path__ + "static/img/icon-koper.f46549f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-koper.png
// module id = ritK
// module chunks = 36